import { useEffect } from 'react'
import CareersHero from '../assets/images/careers-hero.jpg'
import CareerImg from '../assets/images/careers-unlock-potential.jpg'
import { BsBuildingsFill } from "react-icons/bs";
import { GiTeamIdea } from "react-icons/gi";
import { GiBrain } from "react-icons/gi";
//import { HashLink } from 'react-router-hash-link';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';

// .app has `overflow-x: hidden`, which makes its overflow-y compute to `auto`
// and swallows scrollIntoView. The document is the real scroller, so drive
// window directly — same reason the AWS page does.
function scrollToIntro() {
  const el = document.getElementById('careers-intro');
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 20;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top, behavior: reduceMotion ? 'instant' : 'smooth' });
}

export default function Jobs() {
  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  //const handleShow = () => setShow(true);

  // The navbar renders outside this component, so route-specific styling has to
  // be flagged on the body rather than scoped under the page.
  useEffect(() => {
    document.body.classList.add('careers-route');
    return () => document.body.classList.remove('careers-route');
  }, []);

  return (
    <div>
       {/* Hero section */}
      <section className="careers-hero">
        <img
          src={CareersHero}
          alt="Illustration of colleagues climbing a rising bar chart, helping each other up towards a trophy at the top."
          className="careers-hero-art"
        />
        <div className="careers-hero-inner">
          <div className="careers-hero-copy">
            <h1 className="careers-hero-title">Build Your Future With Us</h1>
            <p className="careers-hero-lead">
              Build meaningful work. Grow with people who believe in your potential.
            </p>
            <p className="careers-hero-sub">
              Join us to solve real-world challenges, work with Cloud and AI technologies,
              and build the skills and experience to take your career further.
            </p>
            <button type="button" className="careers-hero-cta" onClick={scrollToIntro}>
              Explore careers
            </button>
          </div>
        </div>
      </section>
      {/* Hero section ends*/}

       {/* Career section 1 */}
       <div className="second-section border-bottom border-secondary" id="careers-intro">
        <div className="container py-5">
      <div className="row px-4 g-4 d-flex justify-content-center">
            <div className="col-md-6">
              <div className="about-img-wrap">
                <img src={CareerImg} alt="Career growth at Jaggulas Consulting" className='about-img careers-unlock-img'/>
              </div>
            </div>
            <div className="col-md-6 text">
              <h2 className='fw-bold mb-1 about-heading'>Unlock Your Potential,</h2>
              <h5 className='fw-bold mb-3'>Join Jaggulas Consulting Family</h5>
              <p>At Jaggulas Consulting, we are committed to creating a work environment that is both positive and inclusive, believing it is essential for success. Our goal is to cultivate a culture where values like joy, respect, empathy, and opportunities for learning and growth go beyond mere words and are central to everything we do. We promote a joyful atmosphere by encouraging collaboration, recognizing achievements, and supporting a balanced work-life dynamic. </p>
              
              <p>Diversity is valued and celebrated, as we understand that different viewpoints drive innovation and progress. Respect and empathy form the foundation of our relationships, fostering a supportive and welcoming environment. Moreover, we offer extensive opportunities for professional growth, empowering our team members to achieve their full potential.
              </p> 
              
            </div>

            <div className="row text-center mt-4">
            <p><b>Come be a part of our team </b> and discover the ideal workplace, where your happiness and personal development are our top priorities.</p>  
            </div>
        </div>

      </div>
      </div>
      {/* Career section 1 ends */}

       {/* Career section 2*/}
       <div className="location-section p-5 border-bottom border-secondary ">
        <div className="container">
          <div className="row pt-5 pb-3 px-sm-4 px-0 mx-sm-5 mx-1 text-center text-light">

            <h2 className="col-12 fw-bold">BENEFITS OF JOINING JAGGULAS CONSULTING</h2>

          </div>

          {/* <div className="row px-sm-4 px-0 mx-sm-5 mx-1 flip-cont text-light">   */}
          <div className="row px-sm-4 px-0 flip-cont text-light">  
          <div className="col-md py-2">
            <div className="flip-card">
                <div class="flip-card-front p-2">
                <div className="vision-icon py-2"><BsBuildingsFill/></div>
                  <h5 className="py-2 mx-2 fw-bold">Work with the Latest Tech and the Best</h5>
                </div>
                <div class="flip-card-back p-2">
                <div className="vision-icon py-2"><BsBuildingsFill/></div>
                <h5>Work with the Latest Tech and the Best</h5>
                  <p className='small'>Work with cutting-edge technology alongside the best in the industry. </p>
                </div> 
              </div>     
            </div>

            <div className="col-md py-2">
            <div className="flip-card">
                <div class="flip-card-front p-2">
                <div className="vision-icon py-2"><GiTeamIdea/></div>
                  <h5 className="py-2 mx-2 fw-bold">Talent Development</h5>
                </div>
                <div class="flip-card-back p-2">
                <div className="vision-icon py-2"><GiTeamIdea/></div>
                <h5>Talent Development</h5>
                  <p className='small'>Fostering talent and career growth to expand your expertise in technology.</p>
                </div> 
              </div>     
            </div>

            <div className="col-md py-2">
            <div className="flip-card">
                <div class="flip-card-front p-2">
                <div className="vision-icon py-2"><GiBrain/></div>
                  <h5 className="py-2 mx-2 fw-bold">Soft skills development</h5>
                </div>
                <div class="flip-card-back p-2">
                <div className="vision-icon py-2"><GiBrain/></div>
                <h5>Soft skills development</h5>
                  <p className='small'>We prioritize soft skills to improve communication, collaboration, leadership.</p>
                </div> 
              </div>     
            </div>

            </div>

          </div>
        </div>
        

      {/* Career section 2 ends */}
 
        {/* Career section 3 ends */}

        {/* <div className="second-section border-bottom border-secondary">
        <div className="container">
        <div className="row pt-5 pb-3 px-sm-4 px-0 mx-sm-5 mx-1 text-center text-light">
            <h2 className="col-12 fw-bold about-heading">Open Position</h2>
        </div>
            <div className="row px-sm-4 px-0 mx-sm-5 mx-1 d-flex justify-content-center my-2 ">

         <div className="col-md-5 vision-cont py-2 mx-2 border border-secondary rounded-4">
            <div className="p-sm-3 p-1 text-center">
         
                  <h5 className="py-2 mx-2 fw-bold">Intern</h5>
                  <div className="p-sm-2 p-0 ">
                  <p><b>Job Type:</b> Hybrid</p>
                  <p><b>Location:</b> Capetown, South Africa</p>

                  <div className="my-3">
                    <button className="see-req p-2 m-2" onClick={handleShow} >View Requirements</button>
                    <HashLink to='/Careers#apply'><button className='new-apply p-2 m-2' style={{border:'1px solid #08baf5, fontSize:13px'}}>Apply</button> </HashLink>
                    
                  </div>
                  </div>
                  </div>
                  </div>
                  
                </div>
              </div>

            </div> */}

        {/* Career section 3 ends */}

      {/* Career section 4 */}
      {/* <div className='second-section border-bottom border-secondary' id='apply'>
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-sm-8 p-5">
            <h5 className='pb-2 fw-bold'>Job Application</h5>
            <p className='small'>Share us your Resume and will reach out to you once we have available positions  if the opportunity suits your Role/Position </p>

            <form id="career-form" className='small py-4' action="https://formspree.io/f/xqakokjv" method="POST">
              <div className="row">
                <div className='col-sm-6 py-2'>
                  <input name= "firstName" type="text" placeholder="First Name*"  className='input-full' required/>
                </div>
                <div className="col-sm-6 py-2">
                  <input name= "lastName" type="text" placeholder="Last Name* " className='input-full' required />
                </div>
              

              <div className='col-sm-6 py-2'>
                <input name= "email" type="email" placeholder="Email*" className='input-full' required/>
              </div>
              <div className='col-sm-6 py-2'> <input name= "mobileNo." type="text" placeholder='Phone number*' className='input-full' required />
              </div>
              </div>

              <div className='py-2'>
                <input type="text" name='linkedinLink' placeholder='LinkedIn profile' className='input-full' />
              </div>

              <div className='py-2'>
              <label htmlFor="">Upload your Cover letter</label>
                <input type="file" name='coverLetter' className='input-full' />
              </div>

              <div className='py-2'>
                <label htmlFor="">Upload your Resume/CV*</label>
                <input type="file" name='CV' placeholder='Upload your Resume/CV*' className='input-full' required/>
              </div>
              <div>
              <button type="submit" className='know-more mt-3 py-2 px-3'>Submit</button> 
              </div>

              
          </form>


          </div>
        </div>
      </div>
      </div> */}


       {/* Career section 4 ends */}



      {/* Modal Section */}

      {/* <>     
       
       <Modal show={show} onHide={handleClose} className='modal-md modal-bg' style={{backgroundColor: '#050B3A'}} >         
           <Modal.Header closeButton></Modal.Header>

           <Modal.Body>  
           <div className="container"> 
           <div className='row'>            

               <div className="col-sm text-light" style={{padding:'20px'}}> 
               <div style={{color:'#050B3A'}}>
                   <h5>Intern</h5>
                <p className="small fw-bold">Role Overview</p>
                  <p className='small' style={{textAlign:'justify'}}>We are seeking a recent graduate in Computer Science to join our team as an Intern. This is a hands-on opportunity to work on real-world projects, develop technical skills and collaborate with seasoned professionals in the tech industry.</p>

                <p className="small fw-bold">Key Responsibilities</p>
                <ul style={{textAlign:'left'}} className='small'>
                  <li>Assist in the development, testing and debugging of software applications.</li>
                  <li>Write and maintain clean, efficient and well-documented code.</li>
                  <li>Perform research on emerging technologies and provide innovative solutions.</li>
                </ul>

                <p className="small fw-bold">Qualifications</p>
                <ul style={{textAlign:'left'}} className='small'>
                  <li>A recent graduate in Computer Science or a related field.</li>
                  <li>Knowledge of web development (HTML, CSS, JavaScript) or backend technologies.</li>
                  <li>Familiarity with version control systems like Git.</li>
                  <li>Strong analytical and problem-solving skills.</li>
                  <li>Eagerness to learn and adapt to new technologies.</li>
                  <li>Good communication and teamwork abilities.</li>
                </ul>
                
                  </div>
               </div>     
           </div>
           </div>
               </Modal.Body> 
               <Modal.Footer className='ms-auto'>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
        
              </Modal.Footer>

       </Modal> 
   </> */}
        {/* Modal Section ends */}


    </div>
  )
}
